import { useEffect } from 'react';

import { Playdeck } from '../lib/playdeck';

const usePlaydeckListener = (): void => {
  useEffect(() => {
    const listener = Playdeck.generateListener({
      getPlaydeckState: (value) => {
        console.log(`isPlayDeckOpened: ${value}`);
      },
      requestPayment: (value) => {
        console.log('Playdeck: request payment');
        console.log(value);
      },
      getPaymentInfo: (value) => {
        console.log('Playdeck: payment info');
        console.log(value);
      },
      invoiceClosed: (value) => {
        console.log('Playdeck: invoice closed');
        console.log(value);
      },
      rewardedAd: (value) => {
        console.log('Playdeck: rewardedAd');
        console.log(value);
      },
      errAd: (value) => {
        console.log('Playdeck: errAd');
        console.log(value);
      },
      skipAd: (value) => {
        console.log('Playdeck: skipAd');
        console.log(value);
      },
      notFoundAd: (value) => {
        console.log('Playdeck: notFoundAd');
        console.log(value);
      },
      startAd: (value) => {
        console.log('Playdeck: startAd');
        console.log(value);
      },
    });

    console.log('init playdeck listener');

    window.addEventListener('message', listener);

    return (): void => {
      window.removeEventListener('message', listener);
    };
  }, []);
};

export { usePlaydeckListener };
